export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_RC_SESSION = 'SET_RC_SESSION'
export const CHANGE_DIVISION = 'CHANGE_DIVISION'
export const GET_ERRORS = 'GET_ERRORS'
export const UPDATE_USER_INFO = 'UPDATE_USER_INFO'
export const UPDATE_ACTIVE_PHONE = 'UPDATE_ACTIVE_PHONE'
export const UPDATE_OFFICE_EXT = 'UPDATE_OFFICE_EXT'
export const PASSWORD_RESETTING = 'PASSWORD_RESETTING'
export const TOKEN_REFRESHED = 'TOKEN_REFRESHED'
